import { render, staticRenderFns } from "./TrainDetail.vue?vue&type=template&id=26f713c6&scoped=true"
import script from "./TrainDetail.vue?vue&type=script&lang=js"
export * from "./TrainDetail.vue?vue&type=script&lang=js"
import style0 from "./TrainDetail.vue?vue&type=style&index=0&id=26f713c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f713c6",
  null
  
)

export default component.exports